import * as React from 'react'
require('../base.module.scss')
import * as cn from 'classnames'
import { BaseComponentProps } from '../Common/extractClassNamesFromProps'
import { extractClassNamesFromProps } from '../Common/extractClassNamesFromProps'
import { Container } from '../Container/Container'
import { IconType, Icon } from '../Icon/Icon'

import * as st from './Block.module.scss'

export interface AlertBlockProps extends BaseComponentProps {
  heading: string
}

export enum MessageTypes {
  success = 'SUCCESS',
  info = 'INFO',
  warning = 'WARNING',
  error = 'ERROR',
  prime = 'PRIME'
}
type MessageBlockState = {
  isVisible?: boolean,
  isChecked?: boolean
}

interface MessageBlockProps extends AlertBlockProps {
  type: MessageTypes
  dismissable?: boolean
  blockId?: string
  onDismiss?: Function
  dismissSeconds?: number
  sticky?: boolean
}

export class MessageBlock extends React.Component<MessageBlockProps, MessageBlockState> {
  blockId: string
  timer?: ReturnType<typeof setTimeout>

  constructor(props: MessageBlockProps) {
    super(props)
    this.blockId = this.props.blockId || `block-${Math.random().toString(36).slice(2)}`
  }
  static defaultProps = {
    dismissable: false,
    setTimeout: 0
  }
  public readonly state: MessageBlockState = {
    isVisible: true,
    isChecked: true
  }

  // Add displayName to preserve the component name on snapshot testing
  displayName = 'MessageBlock'

  setVisibilityState = (visibilityState: boolean) => {
    if (visibilityState) {
      this.setState({
        isVisible: true,
        isChecked: true
      })
    } else {
      this.setState({
        isChecked: false
      })
      // This timer is to allow for the CSS animation (0.3s). This delay is also why isChecked exists.
      setTimeout(() => {
        this.setState({
          isVisible: false
        })
      }, parseInt(st.dismissTransition, 10) );
    }
  }

  componentDidMount() {
    this.setState({
      isVisible: true,
      isChecked: true
    })
    // This prevents the timeout from starting until after the user can see the screen with the Block message.
    requestAnimationFrame(() => {
      if (this.props.dismissSeconds && this.props.dismissSeconds > 0) {
        this.timer = setTimeout(() => {
          this.setVisibilityState(false)
        }, this.props.dismissSeconds * 1000)
      }
    })
  }

  handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    const checkedState = e.currentTarget.checked
    if (this.props.onDismiss && !checkedState) {
      this.props.onDismiss(e)
    }
    this.setVisibilityState(checkedState)
  }


  render() {
    const className = extractClassNamesFromProps(this.props, st.block, {
      [st.hideBlock]: !(this.state.isVisible),
      [st.info]: this.props.type === MessageTypes.info,
      [st.success]: this.props.type === MessageTypes.success,
      [st.warning]: this.props.type === MessageTypes.warning,
      [st.error]: this.props.type === MessageTypes.error,
      [st.prime]: this.props.type === MessageTypes.prime,
    })
    const iconType =
      this.props.type === MessageTypes.info
        ? IconType.ALERT_INFO_BLOCK
        : this.props.type === MessageTypes.success
        ? IconType.ALERT_SUCCESS_BLOCK
        : this.props.type === MessageTypes.warning
        ? IconType.ALERT_WARNING_BLOCK
        : this.props.type === MessageTypes.error
        ? IconType.ALERT_CRITICAL_BLOCK
        : null
    const closeIconType =
      this.props.type === MessageTypes.info
        ? IconType.DISMISS_CLOSE_DARK
        : this.props.type === MessageTypes.success
        ? IconType.DISMISS_CLOSE_DARK
        : this.props.type === MessageTypes.warning
        ? IconType.DISMISS_CLOSE_DARK
        : IconType.DISMISSABLE_CLOSE
    const contentClassName = cn(st.content, {
      [st['without-heading']]: !this.props.heading,
      [st['with-icon']]: Boolean(iconType),
    })
    return (
      <>
        {this.state.isVisible &&
          <div className={cn(
            st.messageBlock, {
              [st.sticky]: Boolean(this.props.sticky)
            }
          )}>
            {(this.props.dismissable || this.props.dismissSeconds || '') &&
              <input type="checkbox" checked={this.state.isChecked} id={this.blockId} className={st.hidden} onChange={this.handleChange} />
            }
            <section className={className}>
              {this.props.dismissable &&
                <label htmlFor={this.blockId} className={st.closeIcon}>
                  <Icon use={closeIconType} />
                </label>
              }
              <Container className={st.wrapper}>
                <div className={contentClassName}>
                  {iconType && <Icon use={iconType} className={st.icon} />}
                  {this.props.heading && <h1>{this.props.heading}</h1>}
                  <p>{this.props.children}</p>
                </div>
              </Container>
            </section>
          </div>
        }
      </>
    )
  }
}
